module.exports = __webpack_public_path__ + "img/pre_min.c9473952.png";